import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=3bafccb6&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=3bafccb6&prod&scoped=true&lang=css&"
import style2 from "./Profile.vue?vue&type=style&index=2&id=3bafccb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bafccb6",
  null
  
)

export default component.exports